//Function to check if the user modules
export const checkUserModules = (moduleCode, modules) => {
    // No logged user ("No registrado") has no modules array - treat it as "module not found"
    // instead of crashing the whole screen.
    if (!Array.isArray(modules)) return -1;
    let module = modules.map(element => element.module_code).indexOf(moduleCode);
    return module
}